import { isHttpError } from './HttpError';
export class CompanionError extends Error {
    constructor({ res, error, code, message, }) {
        super(message);
        this.name = 'CompanionError';
        // Automatically add response if axios error
        if (error && isHttpError(error) && !res) {
            res = error.axiosError.response;
        }
        this.message = message || (error instanceof Error ? error === null || error === void 0 ? void 0 : error.message : undefined) || 'Unknown error';
        this.res = res;
        this.error = error;
        this.code = code;
    }
}
export function isCompanionError(err) {
    return (err instanceof Error &&
        'res' in err &&
        'error' in err &&
        'code' in err &&
        err.name === 'CompanionError');
}
